'use client'
import { useContext } from 'react'

import clsx from 'clsx'

import { PERSONAL_AREA_NAME } from '@/config/constants'

import HeaderContext from './context/HeaderContext'

import Languages from '@/components/molecules/Languages'
import AccessLink from '@/components/molecules/AccessLink'

import Flex from '@/components/atoms/Flex'
import HeaderMenuLogged from './HeaderMenuLogged'
import styles from './Header.module.scss'
import { LOCKED_PERSONAL_AREA } from '@/config/constants'

const HeaderActions = () => {
  const { isOpen, isMobile } = useContext(HeaderContext)
  const showWhen = isMobile !== undefined && (!isMobile || (isMobile && isOpen))

  return (
    <div className={clsx(styles.headerActions, showWhen && styles.visible)}>
      <Flex gap='1rem'>
        {!LOCKED_PERSONAL_AREA && (
          <>
            <AccessLink href={`/${PERSONAL_AREA_NAME}`} />
            <HeaderMenuLogged />
          </>
        )}
        <Languages />
      </Flex>
    </div>
  )
}

export default HeaderActions
